import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { ModalService } from "./modal-service";
import { AuthService } from "./auth.service";
import { AdminAuthGuard } from "./admin-auth.guard";
import { UserAuthGuard } from "./user-auth.guard";
import { SystemService } from "./system.service";
import { UserSessionVo } from "../data/user-session-vo";

const MINUTES_UNITL_AUTO_LOGOUT = 120; // 10 in mins
const MINUTES_UNITL_AUTO_WARNING = 115; // 5 in mins
const CHECK_INTERVAL = 30000; // in ms
const STORE_KEY = "lastAction";
const STORE_KEY_WARNING = "timeWarning";

@Injectable({
  providedIn: "root",
})
export class TimeoutService {
  refreshIntervalId;
  public getLastAction() {
    return parseInt(localStorage.getItem(STORE_KEY));
  }
  public setLastAction(lastAction: number) {
    localStorage.setItem(STORE_KEY, lastAction.toString());
  }
  public getWarning() {
    return parseInt(localStorage.getItem(STORE_KEY_WARNING));
  }
  public setWarning(key) {
    localStorage.setItem(STORE_KEY_WARNING, key.toString());
  }

  constructor(
    private modalService: ModalService,
    private authService: AuthService,
    private adminAuthGuard: AdminAuthGuard,
    private userAuthGuard: UserAuthGuard,
    private systemService: SystemService
  ) {
    this.reset();
    this.initListener();
  }

  initListener() {
    document.body.addEventListener("click", () => this.reset());
    document.body.addEventListener("mouseover", () => this.reset());
    document.body.addEventListener("mouseout", () => this.reset());
    document.body.addEventListener("keydown", () => this.reset());
    document.body.addEventListener("keyup", () => this.reset());
    document.body.addEventListener("keypress", () => this.reset());
  }

  reset() {
    localStorage.clear();
    this.setLastAction(Date.now());
  }

  initInterval() {
    this.refreshIntervalId = setInterval(() => {
      this.check();
    }, CHECK_INTERVAL);
  }

  check() {
    const now = Date.now();
    const timeleftLogout =
      this.getLastAction() + MINUTES_UNITL_AUTO_LOGOUT * 60 * 1000;
    const timeleftWarning =
      this.getLastAction() + MINUTES_UNITL_AUTO_WARNING * 60 * 1000;
    const diffLogout = timeleftLogout - now;
    const diffWarning = timeleftWarning - now;
    if (diffLogout < 0) {
      this.modalService.close("session-timeout-warning");
      this.modalService.open("session-timeout-logout");
      clearInterval(this.refreshIntervalId);
      this.doLogout();
      return;
    }
    if (diffWarning < 0 && !this.getWarning()) {
      this.setWarning(1);
      this.modalService.open("session-timeout-warning");
      return;
    }
  }

  doLogout() {
    this.authService
      .logout(this.systemService.userSessionVo["userId"])
      .subscribe((data) => {
        if (
          JSON.stringify(data["courseOfActionVo"]["storedObject"]) ===
          '"SUCCESS"'
        ) {
          this.systemService.userSessionVo = <UserSessionVo>{};
          this.systemService.setUsername("");
          this.systemService.setdbname("");
          this.adminAuthGuard.reset();
          this.userAuthGuard.reset();
          localStorage.clear();
        }
      });
  }

  disable(toggle) {
    if (toggle) {
      clearInterval(this.refreshIntervalId);
    } else {
      this.initInterval();
    }
  }
}
